import { useEffect, useState } from "react";
import { useParams, Outlet } from "react-router-dom";
import PropertyListComponent from "../propertyNew/PropertyListComponent";
import "./Myspace.css";

const DEFAULT_FILTER_OPTIONS = [
  { label: "Shared", value: "Shared" },
  { label: "Posts", value: "post" },
  { label: "Properties", value: "property" },
  { label: "Follow", value: "follow" },
];

const Myspace = ({
  initialFilter = "property",
  routeBase = "/customer/workspace",
  showFilters = true,
  filterOptions = DEFAULT_FILTER_OPTIONS,
  sectionTitle = "",
}) => {
  const { Id } = useParams();
  const [selectedValue, setSelectedValue] = useState(initialFilter);

  const handleFilterChange = (event) => {
    const nextValue = event.currentTarget.dataset.value;

    if (!nextValue) {
      return;
    }

    setSelectedValue(nextValue);
  };

  useEffect(() => {
    setSelectedValue(initialFilter);
  }, [initialFilter]);

  return (
    <div className="myspace">
      <div className="myspace__content">
        {sectionTitle ? (
          <div className="myspace__heading">
            <h1 className="myspace__heading-title">{sectionTitle}</h1>
          </div>
        ) : null}

        {showFilters ? (
          <div className="myspace__filter-bar">
            <span className="myspace__filter-label">Filter by</span>
            <div className="myspace__filter-pills">
              {filterOptions.map((opt) => (
                <button
                  key={opt.value}
                  type="button"
                  data-value={opt.value}
                  onClick={handleFilterChange}
                  className={`myspace__pill${
                    selectedValue === opt.value ? " myspace__pill--active" : ""
                  }`}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>
        ) : null}

        <div className="myspace__body">
          {Id ? (
            <Outlet />
          ) : (
            <PropertyListComponent
              route={routeBase}
              apiPath="/property/list/my/space"
              method="POST"
              requiresAuth={true}
              mySpace={true}
              selectedValue={selectedValue}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Myspace;
